<div class="main-content table-page table-page--compact consultar-usuarios-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Consulta de Usuarios Clientes</h1>
        <p>Revise, consulte y mantenga los usuarios asignados a clientes desde una sola vista.</p>
      </div>

      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="abrirModalAgregarUsuario()">
        <i class="material-icons">person_add</i>
        <span>Alta de Usuario</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar">
        <mat-form-field appearance="outline" class="table-page__search-field">
          <mat-label>Buscar por email</mat-label>
          <input matInput aria-label="Buscar por email" type="text" maxlength="50" (keyup)="filtroBusqueda($any($event.target).value)" />
        </mat-form-field>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="listaClientes.length > 0; else usuariosEmptyState">
          <thead>
            <tr>
              <th>Usuario cliente</th>
              <th>Apellidos</th>
              <th>Correo</th>
              <th>Usuario</th>
              <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let usuario of listaClientes">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ usuario.nom_persona || 'Sin nombre' }}</strong>
                  <span class="table-page__subtext">{{ usuario.nom_cliente || 'Sin cliente asignado' }}</span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text">{{ usuario.a_paterno || '-' }}</span>
                  <span class="table-page__subtext">{{ usuario.a_materno || '-' }}</span>
                </div>
              </td>
              <td>
                <span class="table-page__text">{{ usuario.correo || '-' }}</span>
              </td>
              <td>
                <span class="table-page__text">{{ usuario.user_nom || '-' }}</span>
              </td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" (click)="mostrarUsuario(usuario)">
                    <i class="material-icons">visibility</i>
                  </button>
                  <button type="button" class="table-page__action-btn" (click)="editarUsuario(usuario)">
                    <i class="material-icons">edit</i>
                  </button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" disabled>
                    <i class="material-icons">delete_forever</i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #usuariosEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else usuariosLoadingState">
            <i class="material-icons">{{ mensajeError ? 'block' : 'group_off' }}</i>
            <strong>{{ mensajeError ? 'No se pudo consultar' : 'No se encontraron usuarios' }}</strong>
            <span>{{ mensajeError || 'Pruebe con otro correo o registre un nuevo usuario desde el botón superior.' }}</span>
          </div>
        </ng-template>

        <ng-template #usuariosLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando usuarios...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} usuarios</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button
              *ngIf="isPageNumber(item); else usuariosPagerEllipsis"
              type="button"
              class="table-page__pager-page"
              [class.is-current]="item === currentPage"
              (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #usuariosPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
